import { useEffect, useReducer, useRef, useState } from "react"
import { useImageLoader } from "../../lib/hooks";
import { isNotEmpty, getAverageRGB } from "../../lib/ep";


type CanvasState = {
	state: "LOADING" | "LOADED" | "LOADED_IMAGES",
	images: object
}

type CanvasAction = 
	| { type: "SET_INDEXED_IMAGES"; payload: object }
	| { type: "GAME_INIT"; };

function reducer(state: CanvasState ,action:CanvasAction):CanvasState{
	switch (action.type) {
		case 'SET_INDEXED_IMAGES':
			return {...state,images:action.payload,state:"LOADED_IMAGES"};
		case 'GAME_INIT':
			return {...state,state:"LOADED"}
		default:
			return state
	}
}

const initialState:CanvasState = {
	state:'LOADING',
	images:[]
};

export const useCanvasMachine = (config,reload_dependencies) => {
	const [state,dispatch] = useReducer(reducer,initialState);
	const [images,setImages] = useState([]);
	const initialized = useRef(false);

	useEffect(()=>{
		const new_images = config?.images();
		if (images.length == 0 && new_images.length == 0) {
			dispatch({type:'SET_INDEXED_IMAGES',payload:{}});
			return;
		}
		setImages(new_images)
	},[...config?.images_dependencies])


	useEffect(()=>{
		if (state.state == 'LOADED_IMAGES') {
			dispatch({type:'GAME_INIT'});
			if (config.gameInit != undefined) {
				config?.gameInit(state);
			}
		}
	},[state.state])
	
	useImageLoader(images, (loaded_images) => {
		const current = {};	
		if (Object.keys(loaded_images).length == 0) return;
		Object.keys(loaded_images).map((image_name) => {
			const image = loaded_images[image_name];

			if(!isNotEmpty(image, 'img')) return;
			const new_image ={
				name:image_name,
				group:image?.group,
				fillPatternImage:image.img,
				fit:image.fit,
				image_w:image.w,
				image_h:image.h,
				use_full_size:(image_name != 'full_bg') ? false : true,
			};
			if (image?.index != undefined) {
				new_image.index = image.index;
			}

			if (image?.get_average_color ?? false) {
				new_image.avg_color = getAverageRGB(image.img);
			}
			
			let image_id = image.id;
			if (Array.isArray(image.id)) image_id = image.id[0];
			current[image_id] = config?.images_adapter != undefined ? config.images_adapter(new_image) : new_image;
			if (Array.isArray(image.id)) {
				image.id.slice(1).map(other_id=>{
					current[other_id] = current[image_id];
				})
				
			}
		});

		dispatch({type:"SET_INDEXED_IMAGES",payload:current});
	});

	return [state,dispatch]
 }